interface SplitHandleProps {
  onPointerDown: (e: React.PointerEvent<HTMLDivElement>) => void
}

export function SplitHandle({ onPointerDown }: SplitHandleProps) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      title="Drag to resize"
      onPointerDown={onPointerDown}
      className="grid w-1.5 flex-none cursor-col-resize place-items-center bg-slate-900/5 select-none hover:bg-blue-600/20"
    >
      <span className="text-[10px] tracking-[-2px] text-slate-400">⋮⋮</span>
    </div>
  )
}
